<template>
  <div class="content">
    <iframe
      v-if="version!=''"
      id="baidutongji"
      name="baidutongji"
      :src="`https://aiplugin.5118.com/Pluginstat/?p=checkBaiDuICP&v=${version}`"
      style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"
    ></iframe>
    <div class="header">
      <span style="width:25%;float: left;">网站备案信息</span>
      <span style="width:70%;">{{true_url}}</span>
      <span class="close" @click="close">×</span>
    </div>
    <div class="body" v-loading="isloading">
      <template>
        <p style="margin-bottom: 10px">
          <span style="font-weight:bold;color:#2f3a74">ICP备案主体信息</span>
        </p>

        <table v-if="isdata" class="table-5118">
          <tbody>
            <tr>
              <td>
                <span>备案/许可证号</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_icp_url(datalist.icp_license)">
                <span class="spancolor">{{datalist.icp_license}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>审核通过时间</span>
              </td>
              <td>
                <span>{{reptime(datalist.confirm_time)}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>主办单位名称</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_company_url(datalist.company_name)">
                <span class="spancolor">{{datalist.company_name}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>主办单位性质</span>
              </td>
              <td>
                <span>{{datalist.company_type}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>旗下备案网站数</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_company_url(datalist.company_name)">
                <span class="spancolor">{{datalist.domain_count}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else style="margin: 60px 5px;">暂无数据</div>
        <p class="labecolor">
          <span style="font-weight:bold;color:#2f3a74">ICP备案网站信息</span>
        </p>
        <table v-if="isdata" class="table-5118">
          <tbody>
            <tr>
              <td>
                <span>网站名称</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_name_url(datalist.site_name)">
                <span class="spancolor">{{datalist.site_name}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>网站首页地址</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_domain_url(get_index_url(datalist.main_gage))">
                <span class="spancolor">{{datalist.main_gage}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>网站负责人</span>
              </td>
              <td>
                <span>{{datalist.owner}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>备案/许可证号</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_icp_url(datalist.site_license)">
                <span class="spancolor">{{datalist.site_license}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>网站域名</span>
              </td>
              <td  style="cursor: pointer;" @click="jump_domain_url(datalist.domain_name)">
                <span class="spancolor">{{datalist.domain_name}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>网站前置审批项</span>
              </td>
              <td>
                <span>{{datalist.site_preconfirm}}</span>
              </td>
            </tr>
            <!-- <tr>
              <td>
                <span>首页是否悬挂备案号：</span>
              </td>
              <td>
                <span>{{datalist.icp_status}}</span>
              </td>
            </tr> -->
          </tbody>
        </table>
        <div v-else style="margin: 60px 5px;">暂无数据</div>
        <div class="lastlabecolor">
          <span style="float: right;">
            <a @click="jump_domain_url(true_url)" target="_blank">查看更多详情</a>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      true_url: "",
      datalist: [],
      firstlist: {},
      isloading:false,
      version:"",
      isdata:true
    };
  },
  computed: {
    apitoken:{
      get(){
        return this.$store.state.checkICPInfo.apitoken;
      },
      set(val){
        this.$store.state.checkICPInfo.apitoken=val;
      }
    }
  },
  mounted() {
    this.listen();
    this.get_userinfo_coookies();
  },
  methods: {
    close() {
      this.$icpinfo.addTarget(window.parent, "parent");
      this.$icpinfo.targets["parent"].send("Close-Baidu-ICP-Info");
    },
    jump_domain_url(url) {
      window.open(this.$geticpurl+"/domain/" + url);
    },
    jump_icp_url(url) {
      window.open(this.$geticpurl+"/icp/" + url);
    },
    jump_name_url(url) {
      window.open(this.$geticpurl+"/name/" + url.encodeUnicode());
    },
    jump_company_url(url) {
      window.open(this.$geticpurl+"/company/" + url.encodeUnicode());
    },
    get_userinfo_coookies() {
      let userInfo = JSON.parse(Cookies.get('_5118_Plug_In_UserInfo') || "{}") || {};
      if(userInfo)this.apitoken = userInfo.plken || '';
      this.$bddiffmessageer.addTarget(window.parent, "parent");
      this.$bddiffmessageer.targets["parent"].send("BaiDu_Rank_ICPList_Check",this.apitoken);

    },
    get_index_url(urls){
      urls=urls.split("|")[0]
      window.console.log(urls);
      return urls
    },
    reptime(time){
      let retime=''
      if(time){
        retime=time.replace('T00:00:00','');
        return retime;
      }
      return retime;

    },
    listen() {
      this.$icpinfo.listen("_5118_Baidu_ICP_ListFirst_Info", msg => {
        if (msg) {
          this.firstlist = JSON.parse(msg);
          this.true_url = this.firstlist.true_url;
          this.version=this.firstlist.version;
          this.isloading=true;
        }
      });
      this.$icpinfo.listen("_5118_BaiduPC_ICP_List_info", msg => {
        if (msg) {
          this.datalist = JSON.parse(msg);
          if(this.datalist.icp_license){
              this.isdata=true;
          }
          else{
              this.isdata=false;
          }
          this.isloading=false;
        }
      });
    }
  }
};
</script>

<style type="text/less" lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";

.content {
  border: 2px solid @theme-color;
  background-color: white;
  font-size: 12px;
  width: 380px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  .header {
    line-height: 24px;
    background-color: @theme-color;
    color: white;
    font-size: 14px;
    text-align: center;
    .close {
      cursor: pointer;
      font-size: 25px;
      width: 5%;
      height: 20px;
      line-height: 16px;
      text-align: center;
      float: right;
      // margin-left: 295px;
    }
  }
  .body {
    padding: 15px;
    .table-5118 {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ccc;
      border-image: initial;
      table-layout: fixed;
      line-height: 18px;
      td {
        font-size: 12px;
        vertical-align: middle;
        padding: 5px 3px;
        border: 1px solid #ccc;
        border-image: initial;
        color: #666;
        padding-left: 5px;
        &:first-child {
          width: 30%;
          background-color: #f2f6fc;
        }
        &:last-child {
          white-space: nowrap;
          width: 240px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .spancolor {
        color: @theme-color;
      }
    }
    .labecolor {
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .lastlabecolor {
      margin-top: 15px;
      font-size: 12px;
      height: 10px;
      a {
        text-decoration: underline;
        color: @theme-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CheckICPInfo.vue